'use strict';

angular.module('studies')
    .component('studiesList', {
        templateUrl: 'js/modules/studies/components/list/template.html',
    });
